import { API_ERROR } from "../../dux/api";
import { REGISTER_USER, SEND_MOBILE_NUMBER, SEND_OTP } from "../../dux/login";
import { showPrompt } from "../../dux/prompt";
import { promptCategoryType } from "../../helpers/constants";
import { logOutUser } from "../../dux/login";
import { destroySession } from "../../helpers/sessionStorageHelper";

import { UPDATE_SPECIAL_SCHEDULE } from "../../dux/bookNow";
import { MARK_DAYS_OFF_HOLIDAY } from "../../dux/markDaysOffHoliday";
import {
  PAYMENT_RECONCILIATION_REPORT,
  PAYMENT_RECONCILIATION_RUN,
} from "../../dux/paymentReconciliation";

const SEND_TEST_EMAIL_TEMPLATE = "SEND_TEST_EMAIL_TEMPLATE";
const SEND_TEST_SMS_TEMPLATE = "SEND_TEST_SMS_TEMPLATE";

const apiError = () => (next) => (action) => {
  if (action.type.endsWith(API_ERROR)) {
    // SAFER: fallback if payload or data is undefined
    const payload = action.payload || {};
    const data = payload.data || {};
    const response = data.response || payload.response || payload.error || "";
    const message =
      typeof response === "string"
        ? response
        : response?.message ||
          response?.error ||
          "An error occurred. Please try again.";
    const status = data.status || payload.status;

    // Handle 401 Unauthorized globally or Handle 999 status code for token expiration/invalid token
    if (status === 401 || status === 999) {
      next(
        showPrompt({
          category: promptCategoryType.GENERIC_ERROR,
          data: {
            message:
              "Your session has expired or you are unauthorized. Please log in again.",
            status,
          },
          autoHideMs: 1500,
          onAutoClose: { type: "SESSION_EXPIRED_REDIRECT" },
        })
      );
      const timeoutId = setTimeout(() => {
        next(logOutUser());
        destroySession();
        window.location.href = "/";
      }, 1500); // Show the popup for 1.5 seconds before redirecting
      return () => clearTimeout(timeoutId);
    }

    switch (action.type) {
      case `${SEND_MOBILE_NUMBER} ${API_ERROR}`:
      case `${SEND_OTP} ${API_ERROR}`:
      case `${REGISTER_USER} ${API_ERROR}`:
      case `${UPDATE_SPECIAL_SCHEDULE} ${API_ERROR}`:
      case `${MARK_DAYS_OFF_HOLIDAY} ${API_ERROR}`:
      case `${SEND_TEST_EMAIL_TEMPLATE} ${API_ERROR}`:
      case `${SEND_TEST_SMS_TEMPLATE} ${API_ERROR}`:
      case `${PAYMENT_RECONCILIATION_REPORT} ${API_ERROR}`:
      case `${PAYMENT_RECONCILIATION_RUN} ${API_ERROR}`:
        next(action);
        break;

      default:
        next(
          showPrompt({
            category: promptCategoryType.GENERIC_ERROR,
            data: { message, status },
          })
        );
        break;
    }
  } else {
    next(action);
  }
};

export default apiError;
